/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-explicit-any */
import $api from "../config/api";
import { dataURItoFile } from "../helpers/dataURItoFile.ts";

export const addEditImg = async (
  id: string,
  data: FormData
) => {
  const formData = new FormData();
  const file = dataURItoFile(data, "image.jpg");
  formData.append("file", file);

  try {
    const response = await $api.put(`/links/thumbnail/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteImg = async (id: string) => {
  try {
    const response = await $api.delete(`/links/thumbnail/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
